import { useEffect } from "react";
import { useStore } from "../contexts/StoreContext";
import { closeCustomerWindow, openCustomerWindow } from "../../utils/customerScreenWindow";

const CustomerScreenHost = () => {
  const { currentStore } = useStore();
  const active = currentStore?.customerScreenAlwaysOn === true || currentStore?.customerScreenActive === true;

  useEffect(() => {
    if (!currentStore?.id) return undefined;
    if (active) openCustomerWindow();
    else closeCustomerWindow();
    return undefined;
  }, [currentStore?.id, active]);

  useEffect(() => {
    const onSettings = (event) => {
      const detail = event.detail || {};
      if (detail.customerScreenAlwaysOn || detail.customerScreenActive) openCustomerWindow();
      else closeCustomerWindow();
    };
    window.addEventListener("customer-screen-settings", onSettings);
    return () => window.removeEventListener("customer-screen-settings", onSettings);
  }, []);

  return null;
};

export default CustomerScreenHost;
